const statusConst = {
  UNPAID: 1,
  PARTIAL: 2,
  PAID: 3,
  CLOSED: 4,
  WAITING_APPROVAL: 111,
  REJECT: 112,
}

const statusColors = [
  { id: 1, name: 'Unpaid', color: '#CF2A28' },
  { id: 2, name: 'Partial', color: '#13A4FF' },
  { id: 3, name: 'Paid', color: '#11A428' },
  { id: 4, name: 'Closed', color: '#11A428' },
  { id: statusConst.WAITING_APPROVAL, name: 'Waiting Approval', color: '#13A4FF' },
  { id: statusConst.REJECT, name: 'Reject', color: '#CF2A28' },
]

export { statusConst, statusColors }
